import React from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Navigation = (props) => {
  return props === undefined ? <></> : (
    <>
      <Navbar
        fixed="top"
        className="smallNav"
        // bg="transparent"
        variant="dark"
        expand="lg"
      >
        <Container className="navWidth ">
          <Navbar.Toggle aria-controls="basic-navbar-nav text-center" />
            <Link to="/" className="navImage m-auto d-lg-none"><img className="img-fluid" src={process.env.REACT_APP_IMAGE_STORAGE + props.icon_image_path} alt=""/></Link>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="m-auto">

              <Nav.Link href="/venue">VENUES</Nav.Link>{" "}
              <Nav.Link href="/about">ABOUT</Nav.Link>
              {/* <Nav.Link href="/people">PEOPLE</Nav.Link> */}
              <Navbar.Brand href="/" className="d-none d-lg-block">
                <img
                  src={process.env.REACT_APP_IMAGE_STORAGE + props.icon_image_path}
                  width="80"
                  className="d-inline-block align-top"
                  alt=""
                />
              </Navbar.Brand>
              <Nav.Link href="/happenings">HAPPENINGS</Nav.Link>
              <Nav.Link href="/gallery">GALLERY</Nav.Link>
              <Nav.Link href="/contact">CONTACT</Nav.Link>
              <Nav.Link href="/joinus" className="d-lg-none">JOIN US</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Navigation;
